import http from "src/common/http";
import {DEVELOPMENT_URL,UPDATE_RIDE_RATE_PER_KM, GET_RIDE_RATE_PER_KM, GET_COMMISSION_OF_RIDE, GET_RIDER_RIDE_HISTORY, ADD_RIDER_COMMISSION_PAID_AMOUNT, UPDATE_RIDER_COMMISSION_PAID_AMOUNT, GET_ALL_RIDE, GET_RIDE_RATE_PER_KM_WITH_COMMISSION_PERCENTAGE, DELETE_COMMISSION_PAYMENT, GET_ALL_DISTRICT, ADD_DISTRICT, DELETE_DISTRICT} from "../constants/apiUrl";

const allRideRatePerKm = () => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_RIDE_RATE_PER_KM, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const updateRideRatePerKm = (vehilcleDetail) => {
    const user = window.sessionStorage.getItem('token');
   
    return http
      .put(DEVELOPMENT_URL + UPDATE_RIDE_RATE_PER_KM,vehilcleDetail, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
      
        return response;
      })
  };


  const getCommissionOfRider = (riderId) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_COMMISSION_OF_RIDE+ riderId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const getRiderRideHistory = (riderId) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_RIDER_RIDE_HISTORY+ riderId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const addRiderPaidCommissionAmount = (paymentDetail) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .post(DEVELOPMENT_URL + ADD_RIDER_COMMISSION_PAID_AMOUNT,paymentDetail, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const  updateRiderPaidCommissionAmount = (paymentId, paymentDetail) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .put(DEVELOPMENT_URL + UPDATE_RIDER_COMMISSION_PAID_AMOUNT+paymentId,paymentDetail, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const getAllRides = () => {
    const user = window.sessionStorage.getItem('token');
    return http
      .get(DEVELOPMENT_URL + GET_ALL_RIDE, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const allRideRatePerKmWithCommissionPercentage = () => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_RIDE_RATE_PER_KM_WITH_COMMISSION_PERCENTAGE, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };

  const deleteCommissionPayment = (id) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .delete(DEVELOPMENT_URL + DELETE_COMMISSION_PAYMENT+id, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
     
  };

  const getAllDistrict = () => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_ALL_DISTRICT, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
     
  };

  const addDistrict = (details) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .post(DEVELOPMENT_URL + ADD_DISTRICT,details, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
     
  };

  const deleteDistrict = (id) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .delete(DEVELOPMENT_URL + DELETE_DISTRICT+id, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
     
  };
  
  export default {allRideRatePerKm,updateRideRatePerKm,getCommissionOfRider, getRiderRideHistory, addRiderPaidCommissionAmount , updateRiderPaidCommissionAmount,getAllRides,allRideRatePerKmWithCommissionPercentage,deleteCommissionPayment,getAllDistrict,addDistrict,deleteDistrict};